import errorImg from "@PUBLIC/M/images/ico/ico_nodata.png";
import {css} from "styled-components";

const ErrorThumbnail = css`
	width: 100%;
	height: 100%;
	background: #f3f3f3 url(${errorImg}) center / 50% no-repeat;
`;

export default ErrorThumbnail;
